import React from 'react';

export default function ClockRewindIcon({
  width = 15,
  height = 16,
  fill = '#171C33',
  opacity = 0.5,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1875 8.9375L12.9378 7.6875L11.6875 8.9375M13.125 8C13.125 11.1066 10.6066 13.625 7.5 13.625C4.3934 13.625 1.875 11.1066 1.875 8C1.875 4.8934 4.3934 2.375 7.5 2.375C9.5637 2.375 11.3678 3.48634 12.3466 5.14318M7.5 4.875V8L9.375 9.25"
        stroke={fill}
        strokeOpacity={opacity}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
